import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Component, Input, Output, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { EquisUtilsModule } from '@tn-equis/core/utils';

class EquisCheckboxComponent {
    constructor() {
        this.checkboxChecked = new EventEmitter();
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.propagateChange = (_) => { };
    }
    checkSelected() {
        if (!this.checkbox.disabled) {
            this.checkboxChecked.emit(this.checkbox);
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    writeValue(obj) {
        if (obj) {
            this.checkbox = obj;
        }
    }
    registerOnTouched(fn) { }
}
EquisCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCheckboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisCheckboxComponent, selector: "z-checkbox, equis-checkbox", inputs: { checkbox: "checkbox", index: "index" }, outputs: { checkboxChecked: "checkboxChecked" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EquisCheckboxComponent),
            multi: true,
        },
    ], ngImport: i0, template: "<div\n  class=\"checkbox-container\"\n  (click)=\"checkSelected()\"\n  [ngClass]=\"{ 'checkbox-container--disabled': checkbox?.disabled }\"\n>\n  <div class=\"checkbox-container__checkbox\">\n    <input\n      type=\"checkbox\"\n      [indeterminate]=\"checkbox?.indeterminate\"\n      [checked]=\"checkbox?.selected\"\n    />\n    <span\n      class=\"checkbox-container__checkbox__checkmark checkbox-base\"\n      [ngClass]=\"{\n        'checkbox-container__checkbox__checkmark--checked checkbox-checked':\n          checkbox?.selected,\n        'checkbox-container__checkbox__checkmark--indeterminate checkbox-indeterminate':\n          checkbox?.indeterminate\n      }\"\n    >\n    </span>\n  </div>\n  <label class=\"checkbox-container__text equis-body-1\">{{\n    checkbox?.text\n  }}</label>\n</div>\n", styles: [".checkbox-container{display:flex;margin-bottom:16px;-webkit-tap-highlight-color:rgba(0,0,0,0);width:100%}.checkbox-container__text{align-self:center;color:#333;display:flex;margin-left:8px}.checkbox-container--disabled{cursor:not-allowed}.checkbox-container--disabled .checkbox-container__text,.checkbox-container--disabled .checkbox-container__text-checkbox,.checkbox-container--disabled .checkbox-container__checkbox{color:#b2b2b2;cursor:not-allowed}.checkbox-container--disabled .checkbox-container__checkbox__checkmark{border-color:#d1d1d1}.checkbox-container--disabled .checkbox-container__checkbox__checkmark--checked,.checkbox-container--disabled .checkbox-container__checkbox__checkmark--indeterminate{background-color:#d1d1d1}.checkbox-container__checkbox{cursor:pointer;display:block;font-size:22px;height:18px;margin:3px;padding-left:16px;position:relative}.checkbox-container__checkbox__checkmark{border-radius:4px;border-style:solid;border-width:2px;height:14px;left:0;position:absolute;top:0;width:14px}.checkbox-container__checkbox__checkmark--indeterminate{align-items:center;display:flex;height:14px;justify-content:center;width:14px}.checkbox-container__checkbox__checkmark--indeterminate:after{background-color:#fff;border-radius:1px;content:\"\";height:2px;width:10px}.checkbox-container__checkbox__checkmark--checked{border:none;height:18px;width:18px}.checkbox-container__checkbox__checkmark--checked:after{bottom:2px;color:#fff;content:\"\\eaaf\";display:block;font-family:iconsFont;font-size:13px;font-weight:600;line-height:13px;position:absolute;right:2px;width:13px}.checkbox-container__checkbox input{height:0;opacity:0;position:absolute;width:0}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-checkbox, equis-checkbox', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => EquisCheckboxComponent),
                            multi: true,
                        },
                    ], template: "<div\n  class=\"checkbox-container\"\n  (click)=\"checkSelected()\"\n  [ngClass]=\"{ 'checkbox-container--disabled': checkbox?.disabled }\"\n>\n  <div class=\"checkbox-container__checkbox\">\n    <input\n      type=\"checkbox\"\n      [indeterminate]=\"checkbox?.indeterminate\"\n      [checked]=\"checkbox?.selected\"\n    />\n    <span\n      class=\"checkbox-container__checkbox__checkmark checkbox-base\"\n      [ngClass]=\"{\n        'checkbox-container__checkbox__checkmark--checked checkbox-checked':\n          checkbox?.selected,\n        'checkbox-container__checkbox__checkmark--indeterminate checkbox-indeterminate':\n          checkbox?.indeterminate\n      }\"\n    >\n    </span>\n  </div>\n  <label class=\"checkbox-container__text equis-body-1\">{{\n    checkbox?.text\n  }}</label>\n</div>\n", styles: [".checkbox-container{display:flex;margin-bottom:16px;-webkit-tap-highlight-color:rgba(0,0,0,0);width:100%}.checkbox-container__text{align-self:center;color:#333;display:flex;margin-left:8px}.checkbox-container--disabled{cursor:not-allowed}.checkbox-container--disabled .checkbox-container__text,.checkbox-container--disabled .checkbox-container__text-checkbox,.checkbox-container--disabled .checkbox-container__checkbox{color:#b2b2b2;cursor:not-allowed}.checkbox-container--disabled .checkbox-container__checkbox__checkmark{border-color:#d1d1d1}.checkbox-container--disabled .checkbox-container__checkbox__checkmark--checked,.checkbox-container--disabled .checkbox-container__checkbox__checkmark--indeterminate{background-color:#d1d1d1}.checkbox-container__checkbox{cursor:pointer;display:block;font-size:22px;height:18px;margin:3px;padding-left:16px;position:relative}.checkbox-container__checkbox__checkmark{border-radius:4px;border-style:solid;border-width:2px;height:14px;left:0;position:absolute;top:0;width:14px}.checkbox-container__checkbox__checkmark--indeterminate{align-items:center;display:flex;height:14px;justify-content:center;width:14px}.checkbox-container__checkbox__checkmark--indeterminate:after{background-color:#fff;border-radius:1px;content:\"\";height:2px;width:10px}.checkbox-container__checkbox__checkmark--checked{border:none;height:18px;width:18px}.checkbox-container__checkbox__checkmark--checked:after{bottom:2px;color:#fff;content:\"\\eaaf\";display:block;font-family:iconsFont;font-size:13px;font-weight:600;line-height:13px;position:absolute;right:2px;width:13px}.checkbox-container__checkbox input{height:0;opacity:0;position:absolute;width:0}\n"] }]
        }], propDecorators: { checkbox: [{
                type: Input
            }], index: [{
                type: Input
            }], checkboxChecked: [{
                type: Output
            }] } });

class EquisContainerCheckboxsComponent {
    constructor(cdRef) {
        this.cdRef = cdRef;
        this.text = '';
        this.listCheckboxs = [];
        this.fatherCheckbox = null;
        this.checkboxChange = new EventEmitter();
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.propagateChange = (_) => { };
    }
    ngAfterViewInit() {
        this.listCheckboxs.forEach((checkbox) => this.initParents(checkbox));
        this.cdRef.detectChanges();
    }
    initParents(checkbox) {
        if (checkbox.listCheckboxs && checkbox.listCheckboxs.length) {
            checkbox.listCheckboxs.forEach((child) => {
                child.parent = checkbox;
                this.checkFather(checkbox);
                if (child.listCheckboxs && child.listCheckboxs.length) {
                    this.initParents(child);
                }
            });
        }
    }
    checkSelected(event) {
        this.checkChildrens(event);
        this.checkFather(this.fatherCheckbox);
        if (event) {
            this.checkboxChange.emit(event);
        }
    }
    checkFather(fatherCheckbox) {
        if (fatherCheckbox && !fatherCheckbox.disabled) {
            fatherCheckbox.selected = false;
            fatherCheckbox.indeterminate = false;
            let selectedCount = 0;
            let disabledCount = 0;
            let indeterminateCount = 0;
            fatherCheckbox.listCheckboxs.forEach((child) => {
                if (child.disabled) {
                    disabledCount += 1;
                }
                else if (child.indeterminate) {
                    indeterminateCount += 1;
                }
                else if (child.selected) {
                    selectedCount += 1;
                }
            });
            let fatherLength = fatherCheckbox.listCheckboxs.length;
            if (disabledCount > 0) {
                fatherLength -= disabledCount;
            }
            if (selectedCount > 0 && selectedCount === fatherLength) {
                fatherCheckbox.selected = true;
                fatherCheckbox.indeterminate = false;
            }
            else if (indeterminateCount > 0 || selectedCount > 0) {
                fatherCheckbox.selected = false;
                fatherCheckbox.indeterminate = true;
            }
            if (fatherCheckbox.parent) {
                this.checkFather(fatherCheckbox.parent);
            }
        }
    }
    checkChildrens(checkbox, isChildren = false) {
        !isChildren
            ? (checkbox.selected = !checkbox.selected)
            : (checkbox.selected = checkbox.selected);
        checkbox.indeterminate = false;
        if (checkbox.listCheckboxs && checkbox.listCheckboxs.length > 0) {
            checkbox.listCheckboxs.forEach((checkboxChildren) => {
                if (checkbox.selected && !checkboxChildren.disabled) {
                    checkboxChildren.selected = true;
                    checkboxChildren.indeterminate = false;
                    if (checkboxChildren.listCheckboxs &&
                        checkboxChildren.listCheckboxs.length > 0) {
                        this.checkChildrens(checkboxChildren, true);
                    }
                }
                else if (!checkbox.selected && !checkboxChildren.disabled) {
                    checkboxChildren.selected = false;
                    checkboxChildren.indeterminate = false;
                    if (checkboxChildren.listCheckboxs &&
                        checkboxChildren.listCheckboxs.length > 0) {
                        this.checkChildrens(checkboxChildren, true);
                    }
                }
            });
        }
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    checkboxChildChange(event) {
        this.checkboxChange.emit(event);
    }
    writeValue(obj) {
        if (obj) {
            this.listCheckboxs = obj;
        }
    }
    registerOnTouched(fn) { }
}
EquisContainerCheckboxsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisContainerCheckboxsComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
EquisContainerCheckboxsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisContainerCheckboxsComponent, selector: "z-checkboxs, equis-checkboxs", inputs: { text: "text", listCheckboxs: "listCheckboxs", fatherCheckbox: "fatherCheckbox" }, outputs: { checkboxChange: "checkboxChange" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EquisContainerCheckboxsComponent),
            multi: true,
        },
    ], ngImport: i0, template: "<label class=\"checkboxs__text\" *ngIf=\"text\">{{ text }}</label>\n<ng-container *ngFor=\"let checkbox of listCheckboxs\">\n  <equis-checkbox\n    [checkbox]=\"checkbox\"\n    (checkboxChecked)=\"checkSelected($event)\"\n  >\n  </equis-checkbox>\n\n  <div class=\"checkboxs__childrens\">\n    <equis-checkboxs\n      *ngIf=\"checkbox.listCheckboxs\"\n      (checkboxChange)=\"checkboxChildChange($event)\"\n      [listCheckboxs]=\"checkbox.listCheckboxs\"\n      [fatherCheckbox]=\"checkbox\"\n    >\n    </equis-checkboxs>\n  </div>\n</ng-container>\n", styles: [".checkboxs__text{color:#b2b2b2;display:flex;font-family:Gibson-Regular,sans-serif;font-size:16px;line-height:1.5;padding-bottom:16px}.checkboxs__childrens{padding-left:27px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: EquisContainerCheckboxsComponent, selector: "z-checkboxs, equis-checkboxs", inputs: ["text", "listCheckboxs", "fatherCheckbox"], outputs: ["checkboxChange"] }, { kind: "component", type: EquisCheckboxComponent, selector: "z-checkbox, equis-checkbox", inputs: ["checkbox", "index"], outputs: ["checkboxChecked"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisContainerCheckboxsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-checkboxs, equis-checkboxs', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => EquisContainerCheckboxsComponent),
                            multi: true,
                        },
                    ], template: "<label class=\"checkboxs__text\" *ngIf=\"text\">{{ text }}</label>\n<ng-container *ngFor=\"let checkbox of listCheckboxs\">\n  <equis-checkbox\n    [checkbox]=\"checkbox\"\n    (checkboxChecked)=\"checkSelected($event)\"\n  >\n  </equis-checkbox>\n\n  <div class=\"checkboxs__childrens\">\n    <equis-checkboxs\n      *ngIf=\"checkbox.listCheckboxs\"\n      (checkboxChange)=\"checkboxChildChange($event)\"\n      [listCheckboxs]=\"checkbox.listCheckboxs\"\n      [fatherCheckbox]=\"checkbox\"\n    >\n    </equis-checkboxs>\n  </div>\n</ng-container>\n", styles: [".checkboxs__text{color:#b2b2b2;display:flex;font-family:Gibson-Regular,sans-serif;font-size:16px;line-height:1.5;padding-bottom:16px}.checkboxs__childrens{padding-left:27px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { text: [{
                type: Input
            }], listCheckboxs: [{
                type: Input
            }], fatherCheckbox: [{
                type: Input
            }], checkboxChange: [{
                type: Output
            }] } });

class EquisCheckboxsModule {
    static forRoot() {
        return {
            ngModule: EquisCheckboxsModule,
        };
    }
}
EquisCheckboxsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCheckboxsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisCheckboxsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisCheckboxsModule, declarations: [EquisContainerCheckboxsComponent, EquisCheckboxComponent], imports: [CommonModule, EquisUtilsModule], exports: [EquisContainerCheckboxsComponent, EquisCheckboxComponent] });
EquisCheckboxsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCheckboxsModule, imports: [CommonModule, EquisUtilsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisCheckboxsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisContainerCheckboxsComponent, EquisCheckboxComponent],
                    imports: [CommonModule, EquisUtilsModule],
                    exports: [EquisContainerCheckboxsComponent, EquisCheckboxComponent],
                }]
        }] });

/*
 * Public API Surface of equis-checkboxs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisCheckboxComponent, EquisCheckboxsModule, EquisContainerCheckboxsComponent };
